import { useEffect, useRef } from 'react';

//interfaces
import { ContentType, ContextLocation, FoundIn, Match, SearchResult } from './interfaces/Search';

//components
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';
import { IconLibrary, ThriveIcon } from 'thrive-components';

//hooks and helpers
import useOnScreen from  '@/components/hooks/useOnScreen';
import { getAppGuid, getContentIdFromContentUrl, getRelativeDate } from './utility';

const Result =({result}: {result: SearchResult}) => {

    const brokenImage = "data:image/svg+xml;base64,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"
    function getFallbackImagePath(mediaType: ContentType | string) {
        if (['video', 'audio', 'text', 'list', 'contact', 'existing', 'html', 'page', 'rss', 'text', 'file', 'image', 'combinedFeed'].includes(mediaType)) {
            return `/Content/img/icons/types/${mediaType}_icon.svg`
        }
        else if(mediaType === 'web') {
            return `/Content/img/icons/types/html_icon.svg`
        }
        return `/Content/img/icons/types/page_icon.svg`
    }

    const ImagePlaceHolder = ({mediaType}: {mediaType: string}) => {
        return <img style={{height: '95%'}} src={getFallbackImagePath(mediaType)} alt={mediaType}/>
    }

    const MediaIcon = ({mediaType}:{mediaType: ContentType | string}) => {
        switch(mediaType) {
            case 'video':
                return <ThriveIcon iconName={IconLibrary.VIDEO} sizeInPx='10' />
            case 'image':
                 return <ThriveIcon iconName={IconLibrary.IMAGE} sizeInPx='10' />
            case 'file':
                return <ThriveIcon iconName={IconLibrary.LIST_ITEM} sizeInPx='10' />
            case 'page':
            case 'title':
                return <ThriveIcon iconName={IconLibrary.LIST_ITEM} sizeInPx='10' />
            case 'text':
                return <ThriveIcon iconName={IconLibrary.ARTICLE} sizeInPx='10' />
            case 'link':
                return <ThriveIcon iconName={IconLibrary.LINK} sizeInPx='10' />
            case 'audio':
                return <ThriveIcon iconName={IconLibrary.AUDIO} sizeInPx='10' />
            default:
                return <></>
        } 
    }

    function addElipsesToTextMatch(contextLocation: ContextLocation, matchText: string): string {
        return (
            `${[ContextLocation.End, ContextLocation.Middle].includes(contextLocation) ? '...' : ''}` +
            `${matchText}` +
            `${[ContextLocation.Start, ContextLocation.Middle].includes(contextLocation) ? '...' :''}`
        )
    }
    
    const GetMatchType = ({match}:{match:Match}) => {
        if (!match) {
            return <><MediaIcon mediaType='page'/>1 Result</>
        }

        switch(match.matchType) {
            case 'media':
                return <><MediaIcon mediaType={match.mediaKind} />{match.caption ? match.caption : match.filename}</>
            case 'title':
                return <><MediaIcon mediaType={'title'} />Title Match</>
            case 'multiple':
                return <><MediaIcon mediaType={match.contentType ? match.contentType : 'page'}/>{match.count === 1 ? '1 match' : `${match.count} matches`}</>
            case 'text':
                return  <><MediaIcon mediaType='text'/><span className='bold'></span>{addElipsesToTextMatch(match.contextLocation, match.context)}</>
            default:
                return <><MediaIcon mediaType='page'/>1 match</>
        }

    }

    const FoundInLocation = ({foundIn, contentUrl}:{foundIn:FoundIn, contentUrl:string}) => {
        return <><span>Found in </span> {foundIn.parentIdsAndTitles.map(i=> <a key={i.id} href={`${contentUrl}&parentId=${i.id}`}>{i.title}</a>)}</>
    }

    function ShowDate({}){
        if (result.publishDate) {
            return <p className='information-item'>Published {getRelativeDate(new Date(result.publishDate))}</p>
        }
        else if (result.modifiedDate) {
            return <p className='information-item'>Last Edit {getRelativeDate(new Date(result.modifiedDate))}</p>
        }
        return <></>
    }

    function getWebappUrl(contentUrl: string, language:string){
        let host: string
        let shortcode = window.location.host.split('.')[0];
        if(window.location.host === "tab.theappbuilder.local:2228") {
            host = 'localhost:9000/'
        }
        else {
            host = window.location.host.replace(shortcode, 'webapp');
        }

        return `//${host}#/${shortcode}/app/${getAppGuid()}${getContentIdFromContentUrl(contentUrl) ? `/${getContentIdFromContentUrl(contentUrl)}` : ''}?language=${language}`

    }

    return (<li className='search-result'>
            <a className='search-link' href={`${window.location.origin}/${result.contentUrl}&parentId=${result.foundIn.parentIdsAndTitles[0].id}`}>
                <div className='search-result-information-container'>
                    <h2 className='result-title'>
                        <span className='title-text'>{result.title}</span>
                        {result.ietfLanguageTag !== 'en-GB' &&
                            <span className='language-alert'>{result.ietfLanguageTag.split('-')[0].toUpperCase()}</span>
                        }
                    </h2>
                    {result.match && <h3 className='match-type'><GetMatchType match={result.match}/></h3>}
                    {result.foundIn && <h3 className='information-item'><span className='title-text'><FoundInLocation foundIn={result.foundIn} contentUrl={`${window.location.origin}/${result.contentUrl}`}/></span></h3>}
                    <div style={{display: 'flex', alignItems:'center'}}>
                        <ShowDate />
                        <span className='stylistic-dot'>{'•'}</span>
                        <a 
                            className='view-on-web-link'
                            target='_blank'
                            rel="noreferrer"
                            href={getWebappUrl(result.contentUrl, result.ietfLanguageTag)}
                        >
                            View on web

                            <ThriveIcon
                                iconName={IconLibrary.EXTERNAL_LINK}
                                color='var(--thriveCMSTextEmphasisColor)'
                                sizeInPx='10'
                                className='search-media-left'
                            />
                        </a>
                    </div>
                </div>
                {result.featuredImage 
                ? <div
                    className='featured-image'
                    aria-label={`${result.title} featured image`}
                    style={{backgroundImage: `url("${result.featuredImage.url}?width=160"), url("${brokenImage}")`}}
                    onError={(e) => {
                        (e.target as HTMLImageElement).classList.add('fallback');

                    }}
                />
                : 
                <div className='featured-image placeholder'>
                    <ImagePlaceHolder mediaType={result.contentType} />
                </div>
                }
            </a>
        </li>
    )
}


const SearchResults = ({isLoading=false, results, searchCompleted, hasMore, getMore, filters, clearFilters}:{isLoading?: boolean, results: SearchResult[], searchCompleted: boolean, hasMore:boolean, getMore:() => void, filters: any, clearFilters:() => void}) => {

    const paginationDiv = useRef<HTMLDivElement>();
    let isVisible = useOnScreen(paginationDiv, document.querySelector('.search-results-container'))


    function areRulesFiltersNotDefault() {
        return !(filters.rulesFilter.includes('CS_Draft') && filters.rulesFilter.includes('CS_Published') && filters.rulesFilter.length === 2)
    }

    function hasFiltersSet(){
        return filters.dateFilter || areRulesFiltersNotDefault() || filters.typeFilter.length 
    }

    
    useEffect(() => {
        if (isVisible && hasMore && !isLoading) {
            getMore();
        }
    }, [isVisible])
    

    return (
        <section className='search-results-container'>
            <ul className='search-results-list'>
                {(!isLoading && !results?.length && searchCompleted) &&
                    <>
                        <p className='no-results no-recent-searches'>No results found</p>
                        {!!hasFiltersSet() && <button className='clear-all-buttons' onClick={clearFilters}>Reset Filters</button>}
                    </>
                    
                }
                {(isLoading && !results?.length)
                    ? <LoadingSpinner size={22}/>
                    : results.map((r, idx) => <Result key={`${r.title}-${r.publishDate}-${idx}`} result={r} />)
                }
                <div key={'paginationDiv'} style={{height:'1px'}} ref={paginationDiv as any}/>
            </ul>
        </section>
    )
}

export default SearchResults;